import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './loader.scss';

const Loader = ({ bubbleClassName = 'blog-text-background-color', dataHook }) => (
  <div className={styles.container} data-hook={dataHook}>
    <span className={classNames(styles.dot, bubbleClassName)} />
    <span className={classNames(styles.dot, bubbleClassName)} />
    <span className={classNames(styles.dot, bubbleClassName)} />
  </div>
);

Loader.propTypes = {
  bubbleClassName: PropTypes.string,
  dataHook: PropTypes.string,
};

export default Loader;
